<template>
    <div v-if="wallet && wallet.accounts && wallet.accounts.length > 0"
        class="w-full flex flex-column surface-0 border-round-xl p-3 overflow-hidden gap-3 mb-3">
        
        <Select v-model="account" :options="accounts" :disabled="false" size="large"
            option-label="name" option-code="code" class='w-full border-2 border-round-xl' placeholder="На счет">
            <template #value="slotProps">
                <div v-if="slotProps.value" class="flex align-items-center gap-2">
                    <AvatarGroup v-if="slotProps.value.network || slotProps.value.code">
                        <Avatar v-if="slotProps.value.code" :image="GetCurrencyImage(slotProps.value.code)" size="small" shape="circle" />
                        <Avatar v-if="slotProps.value.network" :image="GetNetworkImage(slotProps.value.network)" size="small" shape="circle" />
                    </AvatarGroup>
                    <div class="text-sm">{{ GetCurrencyLabel(slotProps.value.code) }}</div>
                </div>
                <span v-else class="flex align-items-center h-full">
                    <div class="text-sm">{{ slotProps.placeholder }}</div>
                </span>
            </template>
            <template #option="slotProps">
                <div class="flex align-items-center w-7-rem gap-2">
                    <AvatarGroup v-if="slotProps.option.network || slotProps.option.code">
                        <Avatar v-if="slotProps.option.code" :image="GetCurrencyImage(slotProps.option.code)" size="small" shape="circle" />
                        <Avatar v-if="slotProps.option.network" :image="GetNetworkImage(slotProps.option.network)" size="small" shape="circle" />
                    </AvatarGroup>
                    <div class="text-sm">{{ GetCurrencyLabel(slotProps.option.code) }}</div>
                </div>
            </template>
        </Select>

        <div class="flex flex-column gap-2">
            <div class="text-sm text-500">Адрес</div>
            <div v-if="account && account.address" class="text-xs xl:text-normal lg:text-sm text-900 font-medium">
                {{ account.address }}
            </div>
        </div>

        <div class="flex flex-column gap-2">
            <div class="text-sm text-500">Сеть</div>
            <div v-if="account && account.network" class="text-900 font-medium uppercase">
                {{ account.network }}
            </div>
        </div>

        <Message v-if="content[lang_].message1" icon="pi pi-exclamation-triangle" severity="warn">
            <span class="text-sm">
                {{ content[lang_].message1 }}
            </span>
        </Message>

        <div class="flex flex-row gap-4">
            <Button v-if="account && account.address"
                label="Скопировать" icon="pi pi-copy" class="flex-1"
                @click="copy(account.address)" severity="secondary"/>
            <!-- <Button icon="pi pi-qrcode" :disabled="false" /> -->
        </div>
    </div>
    <div v-if="wallet && wallet.accounts && wallet.accounts.length > 0" 
        class="flex flex-row gap-4">
        <span class="text-sm text-500">
            {{ content[lang_].message2 }}
        </span>
    </div>

    <Skeleton v-if="loading" height="2rem" class="my-2 border-round-xl" />
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Page from '@/components/sides/Page.vue'

export default {
    props: {
        wallet_id: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            header: {
                en: { title: 'Topup' },
                ru: { title: 'Пополнение' }
            },
            content: {
                ru: { 
                    message1: 'Внимание. Переводите средства согласно адресу пополнения и сети',
                    message2: 'Средства будут зачислены на счет Пополнения. Далее средства можно перевести между счетами.',
                    error: 'Ошибка',
                    notfound: 'Кошелек не найден',
                    copied: 'Скопировано'
                },
                en: { 
                    message1: 'Attention. Transfer funds according to the top-up address and network',
                    message2: 'Funds will be credited to the Top-up account. Then the funds can be transferred between accounts.',
                    error: 'Error' ,
                    notfound: 'Wallet not found',
                    copied: 'Copied'
                }
            },
            loading: true,
            wallet: null,
            accounts: [],
            account: null,
            currencies: []
        }
    },
    components: {
        Page
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 1000});
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.showMess('success', this.content[this.lang_].copied, text)
        },
        GetNetworkImage(val){
            return this.helper.GetNetworkImage(val)
        },
        GetCurrencyImage(val){
            if(!val || this.currencies.length === 0) return null
            return this.helper.GetCurrencyImage(val, this.currencies)
        },
        GetCurrencyLabel(val){
            return this.helper.GetCurrencyLabel(val)
        },
        async getTopup() {
            this.loading = true
            if (!this.wallet_id) {
                this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].notfound)
                this.loading = false
                return
            }
            const data = await this.connect.GetUserWalletById(this.wallet_id).then(res => res)
            if (data) {
                this.wallet = data.data
                if(this.wallet && this.wallet.account_details && this.wallet.account_details.length > 0) {
                    for (let i = 0; i < this.wallet.account_details.length; i++) {
                        this.accounts.push({
                            name: this.wallet.account_details[i].currency.toUpperCase(),
                            code: this.wallet.account_details[i].currency,
                            address: this.wallet.account_details[i].address,
                            network: (this.wallet.account_details[i].network) ? this.wallet.account_details[i].network : ''
                        })
                    }
                    this.account = this.accounts[0]
                }
                this.loading = false
            } else {
                this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].notfound)
                this.loading = false
            }
        },
        getCurrencies(){
            const objList = (this.$store.getters.GetCurrencies) ? this.$store.getters.GetCurrencies : []
            if(!objList)return
            let currencies = []
            for(const [k,v] of Object.entries(objList)){
                currencies.push({
                    code: v.code,
                    name: k.toUpperCase(),
                    image: v.image
                })
            }
            this.currencies = currencies
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        await this.getTopup()
        this.getCurrencies()
    }
}
</script>